import { Modal } from "@next-platform/client-common-spicy-ui";
import { CHARACTER_MODERATION_STATUS, CharacterType, ICharacter, useTranslation } from "@next-platform/client-common-core";
import { Dispatch, JSX, SetStateAction } from "react";

import { Row, SpicyButton, Text } from "@/components/customComponents";
import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import Trans from "@/components/Trans/Trans";

type ModerationWarningModalProps = {
  moderationModalVisible: boolean;
  setModerationModalVisible: Dispatch<SetStateAction<boolean>>;
  character: ICharacter;
  reason_for_moderation?: string;
};

export default function ModerationWarningModal({
  moderationModalVisible,
  setModerationModalVisible,
  character,
}: ModerationWarningModalProps): JSX.Element {
  const { t } = useTranslation();
  const closeHandler = () => {
    setModerationModalVisible(false);
  };

  const isFixRequired = character?.moderationReport?.moderation_status === CHARACTER_MODERATION_STATUS.FIX_REQUIRED;
  const isGroup = character?.type === CharacterType.META;
  const editPath = isGroup ? `/group/edit/${character?.id}` : `/chatbot/edit/${character?.id}`;

  const getTitle = () => {
    if (isFixRequired) return t("myCreation:modal.moderation.title.actionRequired");
    return isGroup ? t("myCreation:modal.moderation.title.groupUnderReview") : t("myCreation:modal.moderation.title.chatbotUnderReview");
  };

  const getMessage = () => {
    if (isFixRequired) {
      return t("chatbot:modal.moderation.fixRequired.message");
    }
    return isGroup ? t("myCreation:modal.moderation.pending.group") : t("myCreation:modal.moderation.pending.chatbot");
  };

  return (
    <Modal title={getTitle()} classNames={{ title: "text-center pl-[28px]" }} open={moderationModalVisible} onOpenChange={closeHandler}>
      <Text variant={"regular"} type="text-center">
        {getMessage()}
      </Text>
      <Row className="justify-center pb-6 gap-2">
        {!isFixRequired && (
          <SpicyButton as={LocalizedLink} variant="primary_large_bordered" color="transparent" to={editPath}>
            <Trans i18nKey="myCreation:modal.moderation.viewDetails" />
          </SpicyButton>
        )}
        {!isFixRequired && (
          <SpicyButton as={LocalizedLink} variant="primary_large" color="primary_strong" to={`/chat/${character?.id}`}>
            <Trans i18nKey="myCreation:modal.moderation.continueChat" />
          </SpicyButton>
        )}
        {!!isFixRequired && (
          <SpicyButton as={LocalizedLink} variant="primary_large" color="primary_strong" to={editPath}>
            <Trans i18nKey="myCreation:modal.moderation.fixMe" />
          </SpicyButton>
        )}
      </Row>
    </Modal>
  );
}
